class PageDatatableReload {
    constructor(reloadPage = true, notToReload = []) {
        this.searchDatatables(reloadPage, notToReload);
    }
    searchDatatables(reloadPage, notToReload){
        let datatables = document.querySelectorAll('table.table');
        datatables.forEach(function (datatable) {
            if(!notToReload.includes(datatable.id)){
                if(datatable.id === 'access-cards-datatable'){
                    if(typeof accessCardsInstance !== 'undefined') {
                        accessCardsInstance.getAccessCards();  // Reload access cards if exists
                    }
                } else {
                    if (datatable.id && $.fn.DataTable.isDataTable('#'+datatable.id)) {
                        $('#'+datatable.id).DataTable().ajax.reload(null, false);
                    }
                }
            }
        });
        if(reloadPage && datatables.length === 0){
            window.location.reload();
        }
    }
}
window.PageDatatableReload = PageDatatableReload;